export function horaNumeroATime(valor) {
    if (valor == null || !Number.isFinite(valor)) return '';
    const h = Math.floor(valor);
    const m = Math.round((valor - h) * 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function timeAHoraNumero(time) {
    if (time == null || time === '') return null;
    if (typeof time === 'number') return time;

    const [h = 0, m = 0] = String(time).split(':').map(value => Number(value));
    return h + m / 60;
}

export function esRangoSinAtencion(horaDesde, horaHasta) {
    return horaDesde === 0 && horaHasta === 0;
}

export function formatearRangoHorario(horaDesde, horaHasta) {
    if (horaDesde == null || horaHasta == null) return '—';
    return `${horaNumeroATime(horaDesde)} – ${horaNumeroATime(horaHasta)}`;
}
